import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import { connect } from 'react-redux'

const styles = theme => ({
    root: {
        display: 'flex',
    },
    formControl: {
        margin: 0
    },
    formGroup: {
        display: 'inline'
    },
    formGroupNoInline: {
        display: 'contents'
    },
    fromHelper: {
        marginLeft: '-8px',
        fontSize: 12
    }
});

class CheckboxesGroup extends React.Component {

    parseChange = ({ name, value, label, disabled }) => {
        let valueCopy = [...this.props.value].map(obj => ({ ...obj }))
        let nameIndex = valueCopy.findIndex(value => value.name === name)
        if (nameIndex > -1) {
            valueCopy[nameIndex] = {
                name,
                value,
                label,
                disabled
            }
        }

        this.props.onChange({
            target: {
                name: this.props.name,
                value: valueCopy,
                label
            }
        })

    }

    render() {
        const { classes } = this.props
        return (
            <div className={classes.root}>
                <FormControl component="fieldset" className={classes.formControl}>
                    <FormHelperText className={classes.fromHelper}>{this.props.utils.toUpperCase()}</FormHelperText>
                    <FormGroup className={`${this.props.noInline ? this.props.classes.formGroupNoInline : ""} ${classes.formGroup}`}>
                        {this.props.value.map(util => {
                            return <FormControlLabel
                                key={util.name}
                                control={
                                    <Checkbox disabled={util.disabled} name={util.name} checked={util.value || false} onChange={event => this.parseChange({ name: util.name, value: event.target.checked, label: util.label, disabled: util.disabled || false })} value={util.name} />
                                }
                                label={util.label || util.name} />
                        })}
                    </FormGroup>
                </FormControl>
            </div>
        );
    }
}

CheckboxesGroup.propTypes = {
    classes: PropTypes.object.isRequired,
    utils: PropTypes.string.isRequired
}


const mapStateToProps = reducers => ({
    languageReducer: reducers.languageReducer.i18n.selector
})

export default withStyles(styles)(connect(mapStateToProps)(CheckboxesGroup))